export const BMG_ONIX = [
  '7208',
  '7209',
  '7210',
  '7309',
  '7310',
  '7311',
  '7670',
  '7671',
  '7672',
  '7673',
  '7674',
  '7675',
  '7676',
  '7677',
  '7678',
  '7679',
  '7680',
  '7681',
  '7682',
  '7683',
  '7684',
  '7685',
  '7686',
  '7687',
  '7723',
  '7724',
  '7725',
  '7726',
  '7727',
  '7728',
  '7729',
  '8011',
];
export const isBmgOnix = (onixCode: string | null = ''): boolean =>
  BMG_ONIX.includes(onixCode?.toString() || '');
